<div [formGroup]="parentFormGroup">
  <div class="row section-row">
    <div class="col-6 section-col">
      <app-yes-no
        [id]="formElementModels['wasDiscrepancyRaised'].id"
        [formElementModel]="formElementModels['wasDiscrepancyRaised']"
        [parentFormGroup]="parentFormGroup"
      ></app-yes-no>
    </div>
    <div *ngIf="showSeriousIncident" class="col-6 section-col">
      <app-yes-no
        [id]="formElementModels['wasSeriousIncidentRaised'].id"
        [formElementModel]="formElementModels['wasSeriousIncidentRaised']"
        [parentFormGroup]="parentFormGroup"
      ></app-yes-no>
    </div>
  </div>
  <div
    class="row section-row"
    *ngIf="
      showWasEverlightInformedOfDiscrepancy ||
      showWasEverlightInformedOfSeriousIncident
    "
  >
    <div class="col-6 section-col">
      <app-yes-no
        [id]="formElementModels['wasEverlightInformedOfDiscrepancy'].id"
        [formElementModel]="
          formElementModels['wasEverlightInformedOfDiscrepancy']
        "
        [parentFormGroup]="parentFormGroup"
        *ngIf="showWasEverlightInformedOfDiscrepancy"
      ></app-yes-no>
    </div>
    <div *ngIf="showSeriousIncident" class="col-6 section-col">
      <app-yes-no
        [id]="formElementModels['wasEverlightInformedOfSeriousIncident'].id"
        [formElementModel]="
          formElementModels['wasEverlightInformedOfSeriousIncident']
        "
        [parentFormGroup]="parentFormGroup"
        *ngIf="showWasEverlightInformedOfSeriousIncident"
      ></app-yes-no>
    </div>
  </div>
  <div class="row section-row" *ngIf="showDetailsOfDiscrepancy">
    <div class="col-12 section-col">
      <app-rich-text-editor
        [id]="formElementModels['detailsOfDiscrepancy'].id"
        [formElementModel]="formElementModels['detailsOfDiscrepancy']"
        [parentFormGroup]="parentFormGroup"
      ></app-rich-text-editor>
    </div>
  </div>
</div>
